import { locations } from "../../common/redux/action_locations";
import {
    FETCH_SCORECARD_DAILY_DATA,
    FETCH_SCORECARD_THIRTY_DAY_DATA,
    CUSTOMER_CLOSING_DAILY_DATA_RECEIVED,
    SALES_CLOSING_DAILY_DATA_RECEIVED,
    SALES_PER_CUSTOMER_DAILY_DATA_RECEIVED,
    CUSTOMER_CLOSING_DATA_RECEIVED,
    SALES_CLOSING,
    SALES_PER_CUSTOMER,
    DAILY_DATA_RECEIVED,
    THIRTY_DAY_DATA_RECEIVED,
    SCORECARD_SELECTED_ITEMS
} from "./constants";
import { CFAuthGetRef } from "auth";
import moment from "moment-timezone";

export function fetchScorecardDailyDataAction(filters) {
    return {
        type: FETCH_SCORECARD_DAILY_DATA,
        fetchCall: fetchScorecardDailyData,
        receivedAction: receivedScorecardDailyData,
        data: {
            filters,
            locations
        }
    };
}

function fetchScorecardDailyData(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/AgentScorecardDaily" + filters.groupName + "?$filter=AgentScorecardId eq " + filters.scorecardType + " and "+filters.groupType+"Id eq " + filters.id,
        originURL: process.env.PUBLIC_URL,
        loaderName: ""
    });
}

function receivedScorecardDailyData(data) {
    let dailyData = [];
    let unFilteredData = [];

    let today = moment();
    let startDate = moment(today).subtract(31, "days");
    let endDate = moment(today).subtract(2, "days");
    if(data.value && data.value.length > 0) {
         
        data.value.forEach(item => {            
            //unfiltered data
            unFilteredData.push ({
                dateKey: moment(item.DateKey).clone(),
                agentScorecardValue: item.AgentScorecardValue
            });

            //filtered data by bounds
            if(moment(item.DateKey).isSameOrBefore(endDate, 'day') && moment(item.DateKey).isSameOrAfter(startDate, 'day')
            && item.AgentScorecardValue !== ""
            && item.AgentScorecardValue !== null)
            
                dailyData.push ({
                    agentScorecardDailyId : item.AgentScorecardDailyId,
                    agentId: item.AgentId,
                    agentName: item.AgentName,
                    dateKey: moment(item.DateKey).clone(),
                    agentScorecardId: item.AgentScorecardId,
                    agentScorecardValue: item.AgentScorecardValue
                });
        });        
    }

    let maxDateObject = getMaxDate(unFilteredData);
    let previousWorkDay = maxDateObject.maxDate;
    let previousWorkDayValue = maxDateObject.maxDateValue;
    
    let moments = dailyData.map(d => d.dateKey);
    let minDate = moments.sort(function(d1, d2) {
        return d1.isBefore(d2);
         })[0];
    
    addFillerDatesData(minDate, startDate, dailyData, previousWorkDay, endDate);
    
    dailyData =  dailyData.sort(function(d1, d2) {
        return d1.dateKey.isBefore(d2.dateKey);
    })

    let scorecardData = {
        scorecardDailyData : dailyData,
        previousWorkDay: previousWorkDay,
        previousWorkDayValue: previousWorkDayValue,
        startDate: startDate,
        endDate: endDate,
        agentScorecardId: dailyData.length > 0 ? dailyData[0].agentScorecardId : null
    }

    return {
		type: DAILY_DATA_RECEIVED,
        scorecardData: scorecardData
    };
}

function addFillerDatesData(minDate, startDate, dailyData, previousWorkDay, endDate) {
    if (minDate !== undefined && minDate.isAfter(startDate, 'day') && dailyData.length > 0) {
        for (let additionaltDay = startDate.clone(); additionaltDay.isBefore(minDate, 'day'); additionaltDay.add(1, 'days')) {
            dailyData.push({
                agentId: dailyData[0].agentId,
                agentName: dailyData[0].agentName,
                dateKey: additionaltDay.clone(),
                agentScorecardId: dailyData[0].agentScorecardId,
                agentScorecardValue: null
            });
        }
    }

    if (previousWorkDay !== null && !previousWorkDay.isSameOrAfter(endDate, 'day') && dailyData.length > 0) {
        for (let additionaltDay = previousWorkDay.clone().add(1, 'days'); additionaltDay < endDate; additionaltDay.add(1, 'days')) {
            dailyData.push({
                agentScorecardDailyId: dailyData[0].agentScorecardDailyId,
                agentId: dailyData[0].agentId,
                agentName: dailyData[0].agentName,
                dateKey: moment(additionaltDay).clone(),
                agentScorecardId: dailyData[0].agentScorecardId,
                agentScorecardValue: null
            });
        }
    }
}

export function fetchScorecardThirtyDayDataAction(filters) {
    return {
        type: FETCH_SCORECARD_THIRTY_DAY_DATA,
        fetchCall: fetchScorecardThirtyDayData,
        receivedAction: receivedScorecardThirtyDayData,
        data: {
            filters,
            locations
        }
    };
}

function fetchScorecardThirtyDayData(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/AgentScorecardThirtyDay"+filters.groupName+"?$filter=AgentScorecardId eq " + filters.scorecardType + " and "+filters.groupType+"Id eq " + filters.id,
        originURL: process.env.PUBLIC_URL,
        loaderName: ""
    });
}

function receivedScorecardThirtyDayData(data) {
    let thirtyDayData = [];

   if(data.value && data.value.length > 0) {
       data.value.forEach(item => {
            thirtyDayData.push ({
                agentScorecardId: item.AgentScorecardId,
                agentScorecardValue: item.AgentScorecardValue
            });
       });
   }

   let scorecardThirtyDayData = {
        agentScorecardId: thirtyDayData.length > 0 ? thirtyDayData[0].agentScorecardId : null,
        agentScorecardValue:  thirtyDayData.length > 0 ? thirtyDayData[0].agentScorecardValue: null
   }

    return {
       type: THIRTY_DAY_DATA_RECEIVED,
       scorecardThirtyDayData: scorecardThirtyDayData
   };
}

export function setScorecardSelectedItems(selectedScorecards) {
    return {
        type: SCORECARD_SELECTED_ITEMS,
        selectedScorecards: selectedScorecards
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case CUSTOMER_CLOSING_DATA_RECEIVED:
        case SALES_PER_CUSTOMER:
        case SALES_CLOSING:
        case THIRTY_DAY_DATA_RECEIVED:
            return {
                ...state,
                scorecardThirtyDayData: action.scorecardThirtyDayData
                
            };        
        case CUSTOMER_CLOSING_DAILY_DATA_RECEIVED:
        case SALES_CLOSING_DAILY_DATA_RECEIVED:
        case SALES_PER_CUSTOMER_DAILY_DATA_RECEIVED:
        case DAILY_DATA_RECEIVED:
            return {
            ...state,
            scorecardData: action.scorecardData
        };
        case SCORECARD_SELECTED_ITEMS:
            return {
                ...state,
                selectedScorecards: action.selectedScorecards
            };
        default:
            return state;
    }
}

function getMaxDate(listOfItems) {
    
    let max = listOfItems.length > 0 ? listOfItems[0].dateKey : null;
    
    let result = {
        maxDate: max,
        maxDateValue: ""
    };
    
    listOfItems.forEach(obj => {

        let item = obj.dateKey;
    
        if(item >= max) {
            max = item;
            result.maxDate = obj.dateKey;
            result.maxDateValue = obj.agentScorecardValue !== "" && obj.agentScorecardValue !== undefined && obj.agentScorecardValue !== null ? obj.agentScorecardValue : "";
        }
    });
   
    return result;
}


// WEBPACK FOOTER //
// ./src/features/scorecard/redux/scorecard_data_actions.js